import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "./Footer";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-paper">
      <header className="sticky top-0 z-50 border-b border-black/10 bg-paper/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1360px] items-center justify-between px-5 py-4 md:px-10">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-2.5 font-display text-xl tracking-tight text-ink">
            <span className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-white shadow-sm">
              <img src="/logo.webp" alt="IYM – I'm Your Man Logo" className="h-10 w-10 object-contain" />
            </span>
            <span className="hidden sm:inline">Im&nbsp;Your&nbsp;Man</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.12em] text-[#4a453d] transition-colors hover:text-ink"
          >
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-20 md:px-10 md:py-28">
        <h1 className="font-display text-4xl leading-[0.95] text-ink md:text-6xl">{title}</h1>
        {updated && (
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-[#8a857b]">{updated}</p>
        )}
        <div className="mt-12 space-y-10">{children}</div>
      </main>

      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="mb-3 font-display text-2xl text-ink">{heading}</h2>
      <div className="space-y-3 text-[15px] leading-relaxed text-[#4a453d]">{children}</div>
    </section>
  );
}
